import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Dashboard from '@/routes/Pages/Dashboard';
import ReservationDetail from './Pages/ReservationDetail';
import Error404 from './Pages/404';
import Login from './Auth/Login';
import storage from '../services/utils/localStorage';
import CustomerDetail from './Pages/CustomerDetail';
import { routes } from '@/constants';
import TaskConfigContainer from './Pages/TaskConfig/Container'

const RestrictedRoute = ({ component: Component, ...rest }) => {
	const { authUser } = useSelector(({ auth }) => auth);
	const { setAuthUser } = useDispatch();

	if (!authUser && storage.getItem('user')) {
		setAuthUser(storage.getItem('user'));
	}

	return (
		<Route
			{...rest}
			render={(props) => (authUser ? (
				<Component {...props} />
			) : (
					<Redirect
						to={{
							pathname: routes.signIn,
							state: { from: props.location },
						}}
					/>
				))}
		/>
	);
};

const Routes = () => {
	const { authUser } = useSelector(({ auth }) => auth);
	const location = useLocation();

	if (location.pathname === '' || location.pathname === '/') {
		return <Redirect to='/dashboard' />;
	} else if (authUser && location.pathname === routes.signIn) {
		return <Redirect to='/dashboard' />;
	}

	return (
		<>
			<Switch>
				<RestrictedRoute path='/dashboard' component={Dashboard} />
				<Route path={routes.signIn} component={Login} />
				<Route path='/reservations/:reservationId' exactly render={(props) => <ReservationDetail key={props.match.params.reservationId} {...props} />} />
				<Route path='/customers/:id' exactly render={(props) => <CustomerDetail key={props.match.params.id} {...props} />} />
				<Route path='/automation-config' exactly render={(props) => <TaskConfigContainer {...props} />} />
				<Route component={Error404} />
			</Switch>
		</>
	);
};

export default Routes;
